import React from "react";
import { Eye, Target } from "lucide-react";
// import patternBackground from "../assets/pattern-background.jpg";
import "./VisionMission.css";

const VisionMission = () => {
  return (
    <section className="vision-mission position-relative py-5 overflow-hidden">
      {/* Background Pattern */}
      {/* <div className="vision-bg">
        <img src={patternBackground} alt="" className="w-100 h-100 object-cover" />
      </div> */}

      <div className="container position-relative">

        <div className="row row28 justify-content-center g-4">
          {/* Vision */}
          <div className="col-md-6">
            <div className="vision-card p-5 border border-warning-subtle animate-fade-in">
              <div className="stat-icon mb-4">
                <Eye size={36} />
              </div>
              <h3 className="fw-bold33 fs-2 mb-3">Our Vision</h3>
              <p className="fs-5 text-muted">
                A prosperous Africa engaged in intra-Africa trade and integrated in the global economy,
                where businesses thrive and economies flourish through strategic financial partnerships.
              </p>
            </div>
          </div>

          {/* Mission */}
          <div className="col-md-6">
            <div
              className="vision-card p-5 border border-primary-subtle animate-fade-in"
              style={{ animationDelay: "150ms" }}
            >
              <div className="stat-icon primary mb-4">
                <Target size={36} />
              </div>
              <h3 className="fw-bold33 fs-2 mb-3">Our Mission</h3>
              <p className="fs-5 text-muted">
                Transform African economies one business at a time through distinctive financial
                solutions, exceptional service, and unwavering commitment to our clients' success.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
